import React, { useEffect } from 'react';
import { FaLaptopCode, FaShoppingCart, FaTools, FaCheckCircle } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';

const timeline = [
    {
        year: "2022",
        title: "Freelancing",
        description: "We started working as freelancers and completed many projects through platforms like Upwork and Fiverr.",
        color: "bg-[#f24e6a]",
        icon: <FaLaptopCode size={18} />,
    },
    {
        year: "2023 – 2024",
        title: "E-Commerce Development",
        description: "We began offering services as a technology partner, focusing on e-commerce development and digital marketing solutions.",
        color: "bg-[#f5b81d]",
        icon: <FaShoppingCart size={18} />,
    },
    {
        year: "2024",
        title: "Extended Services",
        description: "We expanded our departments and started offering services like Shopify Store setup, UI/UX design, branding, SEO, Facebook Ads, and Google Ads.",
        color: "bg-[#00c2ff]",
        icon: <FaTools size={18} />,
    },
    {
        year: "2025",
        title: "Lavanya Infotech Firm",
        description: "We officially registered our brand as Lavanya Infotech Firm and continued serving global clients with full-scale IT solutions.",
        color: "bg-[#6cd091]",
        icon: <FaCheckCircle size={18} />,
    },
];

const CompanyTimeline = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: false });
    }, []);

    return (
        <div className="bg-black xyz text-white py-16 px-4 md:px-10 relative">
            <h1 className="font-poppins text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-5 pb-10">
                Company Timeline
            </h1>

            {/* Vertical Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-pink-500 via-pink-700 to-black z-0"></div>

            {/* Timeline Cards */}
            <div className="relative z-10 flex flex-col gap-16">
                {timeline.map((item, index) => {
                    const isLeft = index % 2 === 0;

                    return (
                        <div
                            key={index}
                            data-aos={isLeft ? "fade-right" : "fade-left"}
                            className={`flex flex-col md:flex-row items-center justify-between gap-8 relative ${isLeft ? 'md:flex-row' : 'md:flex-row-reverse'
                                }`}
                        >
                            {/* Dot in center */}
                            <div className="absolute left-1/2 transform -translate-x-1/2 w-5 h-5 rounded-full bg-white border-4 border-pink-500 z-10"></div>

                            {/* Date */}


                            <div
                                className={`w-full md:w-1/4 text-sm text-gray-400 
    ${isLeft ? 'text-left pl-10 lg:pl-52' : 'text-right pr-10  lg:pr-52'} 
    md:text-center`}
                            >
                                {item.year}
                            </div>

                            {/* Content Box */}
                            <div className="w-full md:w-3/5 flex justify-center relative z-20">
                                <div className={`w-full max-w-md ${item.color} p-5 rounded-xl text-white shadow-lg`}>
                                    <div className="flex items-center gap-2 mb-2 font-bold text-lg">
                                        <span>{item.icon}</span>
                                        <span>{item.title}</span>
                                    </div>
                                    <p className="text-sm leading-relaxed">{item.description}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CompanyTimeline;
